import { extend } from "@react-three/fiber";
import { SplatMesh as SparkSplatMesh } from "@sparkjsdev/spark";

export const SplatMesh = extend(SparkSplatMesh);
